module.exports = __webpack_public_path__ + "static/media/gt.pictogram.45b5ed42.svg";